import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  IconPaths,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import {
  deleteUnidade,
  getContatosOfAgendamentosByUnidade,
  getEsusConfigUnidade,
  getUnidadeById,
} from '../../core/_requests'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { UnidadeModal } from '../../components/modal/UnidadeModal'
import { EsusConfigModal } from '../../components/modal/EsusConfigModal'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { UnidadeList } from '../../core/_models'
import { useAuth } from '../../../../../auth'

type Props = {
  unidade: UnidadeList
}

export const UnidadesActionsCell: FC<Props> = ({ unidade }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const { id } = unidade
  const nome = unidade.nome || 'Unidade/Setor'

  const openEditModal = () =>
    showModal({
      title: 'Editar Unidade',
      content: <UnidadeModal />,
      fetchers: {
        unidade: () => getUnidadeById(id),
        contato: () => getContatosOfAgendamentosByUnidade(id),
      },
    })

  // Excluir é destrutivo (não há inativar para unidade): confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir unidade/setor?',
      text: `${nome} e seus endereços serão excluídos. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteUnidade(id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluída.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  const openEsusConfigModal = async () => {
    try {
      const detalhe = await getUnidadeById(id)
      const empId = Number(detalhe?.empresa?.id || currentUser?.empresas?.[0]?.id)
      if (!empId) {
        showError(new Error('Não foi possível identificar a instituição da unidade.'))
        return
      }
      showModal({
        title: `Configuração e-SUS APS — ${detalhe?.nome || 'Unidade'}`,
        content: <EsusConfigModal empresaId={empId} unidadeId={id} onSaved={refetch} />,
        fetchers: {
          config: () => getEsusConfigUnidade(empId, id),
        },
      })
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        { label: 'Configuração e-SUS', onClick: openEsusConfigModal },
        { label: 'Listar endereços', onClick: () => navigate(`/apps/enderecos/unidade/${id}`) },
        { label: 'Excluir', onClick: askDelete, danger: true, divider: true },
      ]}
    />
  )
}
